import { Box, Divider } from '@mui/material';

import SummaryCell from './SummaryCell';

const CellDivider = ({ sx }) => (
  <Divider
    orientation="vertical"
    sx={{ borderColor: '#FFF', height: { xs: 56, lg: 83 }, mx: 3, ...sx }}
  />
);

const OverviewBoard = ({ data }) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: { xs: 'wrap', tl: 'initial' },
          maxWidth: { xs: 340, tl: 'none' },
          m: { xs: 'auto', tl: 'unset' },

          '& > div': {
            mb: { xs: 0, tl: 0 },
            width: { xs: 'calc(50% - 16px)', tl: 'auto' },

            '&:last-child': {
              mb: 0,
            },
          },
          '& > hr': {
            mb: { xs: 0, tl: 0 },
            mx: { xs: 1, tl: 3 },
          },
        }}
      >
        <SummaryCell label={data[0].title} value={data[0].value} />
        <CellDivider />
        <SummaryCell
          label={data[1].title}
          value={data[1].value}
        />
      </Box>
    </>
  );
};

export default OverviewBoard;
